import { defineComponent as _defineComponent } from 'vue'
import { AvailabilityInterface } from '@/models/Availability';
import { Profile } from '@/models/Profile';
import { User } from '@/models/User';

import {
  computed, ref, watch
} from 'vue';
import { useRoute } from 'vue2-helpers/vue-router';
import RecommendWarningErrors from '@/views/recommendations/components/RecommendWarningErrors.vue';
import RecommendNotMatchingReasons from '@/views/recommendations/components/RecommendNotMatchingReasons.vue';
import RecommendedMessage from '@/views/recommendations/components/recommend-project-to-users/RecommendedMessage.vue';
import useRecommendation from '@/views/recommendations/composables/useRecommendation';
import RecommendationMessageBox from '@/views/recommendations/components/RecommendationMessageBox.vue';
import SidebarUserSelect from '@/components/molecules/SidebarUserSelect.vue';
import BCXSidebarHelpContainer from '@/components/molecules/BCXSidebarHelpContainer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendProjectToUsers',
  emits: ['recommended', 'selected', 'loaded'],
  setup(__props, { emit }) {



const user = ref<User | null>(null);
const availability = ref<AvailabilityInterface | null | false>(null);
const profile = ref<Profile | null>(null);

const route = useRoute();

const userId = computed(() => user.value?.userId ?? '');
const projectId = computed(() => route.params.projectId ?? '');

const {
  notMatchingReasons, recommendationKey, messageKey,
  recommend,
  hasBeenRecommended,
  message,
  cantRecommend,
} = useRecommendation(projectId, userId);

const resultMessageKey = computed(() => {
  if (availability.value === false) return 'recommendations.apiErrors.availability_fetch_error';
  return recommendationKey.value ? messageKey.value : null;
});

watch(user, (user) => {
  hasBeenRecommended.value = false;
  if (user) emit('selected');
});


return { __sfc: true,emit, user, availability, profile, route, userId, projectId, notMatchingReasons, recommendationKey, messageKey, recommend, hasBeenRecommended, message, cantRecommend, resultMessageKey, RecommendWarningErrors, RecommendNotMatchingReasons, RecommendedMessage, RecommendationMessageBox, SidebarUserSelect, BCXSidebarHelpContainer }
}

})